import { observable, action } from 'mobx';
import fetchDataHelper from '../helpers/fetchDataHelper';
import toastNotificationHelper from '../helpers/toastNotificationHelper';

export interface IFilterStore {
    openFilterId: number;
    filters: IFilter[];
	inProgress: boolean;
    setOpenId(id: number): void;
    getFilter(id: number): IFilter;
    initFilters(): Promise<void>;
    addFilter(): void;
    removeFilter(id: number): void;
    saveFilter(filter: IFilter): void;
    cancelFilter(): void;
}

export interface IFilter {
    id: number,
    //index: number,
    symbols: string[],
	symbolsAutoSelect: boolean,
    intervals: number[],
    priceChangeDirection: number,
    priceChangePercentage: number,
	volumeType: number,
	volume: number,
    soundIndex: number,
    color: string,
    telegramNotifications: boolean,
    browserNotifications: boolean,
    apiNotifications: boolean
}

class FilterStore implements IFilterStore {

	@observable filters: IFilter[] = [];  
	@observable openFilterId: number = undefined;
	@observable inProgress: boolean = false;

	@action.bound setOpenId(id: number): void {
		this.openFilterId = id;		
	}

	@action.bound getFilter(id: number): IFilter {
		return this.filters.find(f => f.id == id);
	}

	@action initFilters(): Promise<void> {
		this.setOpenId(undefined);
		return this.loadFilters();        
	}

	@action.bound addFilter(): void {
		const newFilter = this.createFilter();

		this.filters.push(newFilter);
		this.setOpenId(newFilter.id);
	}

	@action.bound removeFilter(id: number): void {
		// var filterToLet = this.filters.filter(f => f.id !== id);
		// this.filters = filterToLet;

		// this.reindexFilters();
		// this.saveFiltersInner().then(() => {
		// 	this.setOpenId(undefined);
		// });
		this.deleteFilterInner(id).then(() => this.setOpenId(undefined));
	}

	@action.bound saveFilter(filter: IFilter): void {
		this.saveFilterInner(filter).then(() => this.setOpenId(undefined));
	}

	@action.bound cancelFilter(): void {
		this.initFilters();
	}

	private setFilters(filters: IFilter[]): void {
		this.filters = filters;
	}

	private loadFilters(): Promise<void> {
		return fetchDataHelper.getReturnJson("/filter/getFilters")
			.then(
				(result) => {
					this.setFilters(result);
					
					this.inProgress = false;
					return Promise.resolve();
				},
				(error) => {
					toastNotificationHelper.notifyError('Init filters failed');
					console.log('Init filters failed: ' + error);
					this.inProgress = false;
					return Promise.reject();
				}
			);
	}

	// private saveFiltersInner(): Promise<void> {
	// 	return fetchDataHelper.postReturnJson("/filter/saveFilters", this.filters)
	// 		.then(
	// 			(result) => {
	// 				this.setFilters(result);
					
	// 				this.inProgress = false;
	// 				return Promise.resolve();
	// 			},
	// 			(error) => {
	// 				toastNotificationHelper.notifyError('Save filters failed');
	// 				console.log('Save filters failed: ' + error);
	// 				this.inProgress = false;
	// 				return Promise.reject();
	// 			}
	// 		);
	// }

	private saveFilterInner(filter: IFilter): Promise<void> {

			// var filtersToSave = this.filters.filter(f => f.id !== id)
			// if (filtersToSave.length != 1)
			// {
			// 	toastNotificationHelper.notifyError('Save filter failed');					
			// 	return Promise.reject();
			// }

			return fetchDataHelper.post("/filter/insertOrUpdateFilter", filter)
				.then(
					(result) => {
						this.loadFilters();
						
						this.inProgress = false;
						return Promise.resolve();
					},
					(error) => {
						toastNotificationHelper.notifyError('Save filter failed');
						console.log('Save filter failed: ' + error);
						this.inProgress = false;
						return Promise.reject();
					}
				);
	}

	private deleteFilterInner(id: number): Promise<void> {

		return fetchDataHelper.delete("/filter/deleteFilter?id=" + id)
			.then(
				(result) => {
					this.loadFilters();
					
					this.inProgress = false;
					return Promise.resolve();
				},
				(error) => {
					toastNotificationHelper.notifyError('Delete filter failed');
					console.log('Delete filter failed: ' + error);
					this.inProgress = false;
					return Promise.reject();
				}
			);
}

	private createFilter(): IFilter {
		return {
			id : Date.now(),			
			//index : this.filters.length + 1,
			symbols : [],
			symbolsAutoSelect: false,
			intervals : [],
			priceChangeDirection : 0,
			priceChangePercentage : 3,
			volumeType: 0,
			volume: 0,
			soundIndex : 0,
			color : '#fff',
			telegramNotifications : false,
			browserNotifications : false,
			apiNotifications : false
		}
	}

	// private reindexFilters(): void {
	// 	var index = 1;
	// 	this.filters.forEach(f => {
	// 		f.index = index++;
	// 	});
	// 	this.setFilters(this.filters);
	// }
}

export default new FilterStore();